import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ItemLocationHistoryEntryDetailFragmentDoc } from '../fragments/itemLocationHistoryEntry.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetItemLocationHistoryPaginatedQueryVariables = Types.Exact<{
  item_id: Types.Scalars['ID'];
  skip: Types.Scalars['Int'];
  take: Types.Scalars['Int'];
}>;


export type GetItemLocationHistoryPaginatedQuery = { __typename?: 'Query', getItemLocationHistoryPaginated?: { __typename?: 'GetItemLocationHistoryPaginatedResponse', total: number, items: Array<{ __typename?: 'ItemLocationHistoryEntry', id: string, item_id: string, current_location_id: string, next_location_id?: string | null, arrival_date: string, departure_date?: string | null, current_location_name?: string | null, next_location_name?: string | null, booked_by_id?: string | null, booked_by?: string | null, order_fulfillment_id?: string | null, status?: Types.ContainerStationStatus | null, item_type?: { __typename?: 'ItemType', id: number, name: string, category: Types.ItemTypeCategory, archived: boolean, image_url?: string | null, color_hex_code?: string | null } | null, event?: { __typename?: 'EventReduced', id?: string | null, name?: string | null } | null, pictures: Array<{ __typename?: 'OrderFulfillmentPicture', id: string, url: string, url_full_size: string, created_at: string, created_by_id: string, created_by_name: string, comment?: string | null, taken_at?: string | null, street?: string | null, city?: string | null, country_code?: string | null, postal_code?: string | null, latitude?: number | null, longitude?: number | null }>, container_type_amounts: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, container_type_name: string, container_type_image?: string | null, amount: number, amount_sealed: number }> }> } | null };


export const GetItemLocationHistoryPaginatedDocument = gql`
    query GetItemLocationHistoryPaginated($item_id: ID!, $skip: Int!, $take: Int!) {
  getItemLocationHistoryPaginated(item_id: $item_id, skip: $skip, take: $take) {
    items {
      ...ItemLocationHistoryEntryDetail
    }
    total
  }
}
    ${ItemLocationHistoryEntryDetailFragmentDoc}`;

/**
 * __useGetItemLocationHistoryPaginatedQuery__
 *
 * To run a query within a React component, call `useGetItemLocationHistoryPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemLocationHistoryPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemLocationHistoryPaginatedQuery({
 *   variables: {
 *      item_id: // value for 'item_id'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetItemLocationHistoryPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetItemLocationHistoryPaginatedQuery, GetItemLocationHistoryPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItemLocationHistoryPaginatedQuery, GetItemLocationHistoryPaginatedQueryVariables>(GetItemLocationHistoryPaginatedDocument, options);
      }
export function useGetItemLocationHistoryPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItemLocationHistoryPaginatedQuery, GetItemLocationHistoryPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItemLocationHistoryPaginatedQuery, GetItemLocationHistoryPaginatedQueryVariables>(GetItemLocationHistoryPaginatedDocument, options);
        }
export type GetItemLocationHistoryPaginatedQueryHookResult = ReturnType<typeof useGetItemLocationHistoryPaginatedQuery>;
export type GetItemLocationHistoryPaginatedLazyQueryHookResult = ReturnType<typeof useGetItemLocationHistoryPaginatedLazyQuery>;
export type GetItemLocationHistoryPaginatedQueryResult = Apollo.QueryResult<GetItemLocationHistoryPaginatedQuery, GetItemLocationHistoryPaginatedQueryVariables>;